import navigateToRoute from 'owa-router/lib/navigateToRoute';
import type { Middleware, MiddlewareAPI, Dispatch } from 'redux';
import type { Action, LeftNavItemType } from 'people/lib/shared';
import { Route, setRouteAction } from 'people/lib/appstate';
import {
    contactEditorNewContactSaveClickedAction,
    contactEditorExistingContactSaveClickedAction,
    unifiedGroupFocusAction,
    loadGroupForDeepLinkAction,
} from 'people/lib/hub';
import { menuEntryClickedAction } from 'people/lib/appchrome';
import { getRouteForCurrentGroup, getRouteForGroupFolder } from '../getRouteForGroup';
import { searchSuggestedPersonaClickedAction, searchResultResetAction } from 'people/lib/searchbox';

const middleware = (_store: MiddlewareAPI) => (next: Dispatch) => (action: Action<{}>) => {
    const result = next(action);
    if (action.type === setRouteAction.toString()) {
        const newRoute = (action as Action<{ route: Route }>).payload.route;
        navigateToRoute([newRoute]);
    } else {
        navigateToRouteForGroup(action);
    }

    return result;
};

function navigateToRouteForGroup(action: Action<{}>) {
    if (action.type === loadGroupForDeepLinkAction.toString()) {
        const groupSmtp = (action as Action<{
            hubPersonaId: string;
            groupSmtp: string;
            leftNavItemId?: string;
        }>).payload.groupSmtp;

        navigateToRoute(getRouteForCurrentGroup(groupSmtp));
    } else if (action.type === unifiedGroupFocusAction.toString()) {
        const groupSmtp = (action as Action<{
            unifiedGroupId: string;
            unifiedGroupSmtp: string;
        }>).payload.unifiedGroupSmtp;

        navigateToRoute(getRouteForCurrentGroup(groupSmtp));
    } else if (action.type === menuEntryClickedAction.toString()) {
        const leftFolderType = (action as Action<{
            folderId: string;
            folderType: LeftNavItemType;
        }>).payload.folderType;

        navigateToRoute(getRouteForGroupFolder(leftFolderType));
    } else if (
        action.type === searchSuggestedPersonaClickedAction.toString() ||
        action.type === contactEditorNewContactSaveClickedAction.toString() ||
        action.type === contactEditorExistingContactSaveClickedAction.toString() ||
        action.type === searchResultResetAction.toString()
    ) {
        navigateToRoute(['']);
    }
}

export const routeMiddleware = middleware as Middleware;
